import React from 'react';
import { Link } from 'react-router-dom'; // for navigation
import banner from '../assets/navbar_banner.jpg'; // Import the banner image using the correct relative path
import { Helmet } from 'react-helmet-async';

const NavbarBanner = () => {
  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>Shop T-Shirts & Hoodies for Vacations | Stylish Apparel</title>
        <meta 
          name="description" 
          content="Explore our exclusive collection of T-shirts and Hoodies, perfect for vacations. Stay stylish and comfortable with our premium apparel." 
        />
        <meta 
          name="keywords" 
          content="T-shirts, Hoodies, vacation wear, stylish apparel, premium T-shirts, comfortable clothing, vacation outfits, shop online, casual wear" 
        />
      </Helmet>
    
    <div
      className="relative w-full bg-no-repeat bg-center flex"
      style={{
        backgroundImage: `url("https://res.cloudinary.com/dypkxqirq/image/upload/v1753353543/navbar_banner_k5xhkc.webp")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        height: '300px',
        width: '100%',
      }}
    >
      {/* Overlay for text readability */}
      <div className="absolute inset-0 bg-black opacity-5"></div>

      {/* Text and Button container */}
      <div
        className="absolute text-center lg:text-left text-white z-10 px-4 sm:px-6 md:px-8 lg:px-12 w-full lg:w-1/2 lg:ml-24"
        style={{
          marginTop: '60px',
          marginBottom: '60px',
        }}
      >
        {/* Heading */}
        <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-4 lg:mb-6">
          Enjoy up your vacations
          <br /> in the best T-shirts & Hoodies
        </h1>

        {/* Subtext */}
        <p className="text-sm sm:text-base md:text-lg lg:text-xl mb-6 lg:mb-8 px-4 sm:px-0">
          T-shirts that keep you moving
        </p>

        {/* Buttons */}
        <div className="space-y-2 sm:space-y-0 sm:space-x-4 flex flex-col sm:flex-row justify-center lg:justify-start">
          <Link to="/collection">
            <button className="bg-[#FF4902] text-white rounded-full py-2 px-6" onClick={() => window.scrollTo(0, 0)}>
              Shop Now
            </button>
          </Link>
          <Link to="/contact">
            <button className="bg-[#FF4902] text-white rounded-full py-2 px-6" onClick={() => window.scrollTo(0, 0)}>
              Contact Us
            </button>
          </Link>
        </div>
      </div>
    </div>
    </>
  );
};

export default NavbarBanner;
